import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/abhinavchat/abhinavchat-portfolio'
      className='link footer__link'
    >
      Created By Abhinav Chaturvedi
    </a>
  </footer>
)

export default Footer
